export default "__VITE_ASSET__BbcYchIb__"